import type { Category, Link } from '@/types/shared-types';

export const isLinkList = function (items: Category[] | Link[] | undefined): items is Link[] {
    return (items as Category[])[0].items === undefined;
};
